import React from 'react';
import PropTypes from 'prop-types';
import {Icon, InputActionButton} from '@stubhub/bamboo';
import {t} from '@stubhub/bamboo-tokens';
import {INPUT_ICON_ACCESSIBILITY_TEXT} from '../InputField/utils';
import {useIntl} from 'react-intl';

const SearchInputRightAction = ({handleActionClick}) => {
  const intl = useIntl();

  return (
    <InputActionButton
      className="InputField__icon-wrapper"
      onClick={handleActionClick}
    >
      <Icon
        id="InputField__close-icon"
        description={intl.formatMessage(INPUT_ICON_ACCESSIBILITY_TEXT.desc)}
        title={intl.formatMessage(INPUT_ICON_ACCESSIBILITY_TEXT.title)}
        name="Close"
        width="12"
        height="12"
        fill={t('color-neutral')}
      />
    </InputActionButton>
  );
};

SearchInputRightAction.propTypes = {
  handleActionClick: PropTypes.func
};

export default SearchInputRightAction;
